import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import PayrollField from 'main/stores/payroll/PayrollField';

class PayrollSection extends DomainObject {
  name;
  payrollFields;

  _relations = {
    payrollFields: [PayrollField]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      payrollFields: observable
    });

    this.merge(other);
  }
}

export default PayrollSection;
